import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";

export namespace DoppeActionTypeDevModals {
    export interface ActionSettings {

    }
}

export const doppeActionTypeDevModals = doppeActionTypeDefineMetadata<DoppeActionTypeDevModals.ActionSettings>({
    id: 'io.bymo.action/dev-modals',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: true,
    canRenderInPage: true,
    skipReportingOnGoalAchievedOnActionButtonClick: true
});